import { type MotionValue } from 'motion/react'
import { type ReactNode } from 'react'
import {
  StickyViewHeader,
  StickyViewHeaderMain,
} from '@/components/StickyViewHeader'

export interface ScopeChangeRequestHeaderProps {
  scrollOffset: MotionValue<number>
  children?: ReactNode
}

export function ScopeChangeRequestHeader({
  scrollOffset,
  children,
}: ScopeChangeRequestHeaderProps) {
  return (
    <StickyViewHeader scrollOffset={scrollOffset}>
      <StickyViewHeaderMain>{children}</StickyViewHeaderMain>
    </StickyViewHeader>
  )
}
